import React from 'react'
import _ from 'lodash'
import {
  Accordion,
  Table,
  Popup
} from 'camino-react'

import SurveyModalContent from 'Components/Reports/Surveys/SurveyModalContent'

const ReportAccordion = ({ surveyGroups, filteredUsers }) => {
  const showUserField = !_.isEmpty(filteredUsers)

  const accordionTableColumns = [
    {
      text: 'Ticket',
      accessor: 'ticket_id',
      maxWidth: '150',
      Cell: row => (
        <a className="link link--decorated link--initial-size link--thick" href={row.original.ticket_href}>
            {`Ticket #${row.value}`}
          </a>
      )
    },
    { text: 'Taken by', accessor: 'respondee_email', maxWidth: '200' },
    { text: 'Answers', accessor: 'answers', Cell: row => {
        const stringLabel = _.truncate(_.keys(row.value)[0], {
          'length': '40',
          'separator': /,? +/
        })

        return (
        <Popup
          modal
          trigger={() => (
            <span
              style={{ cursor: 'pointer', color: '#00baea' }}
            >
              {stringLabel}
            </span>
          )}
        >
          <SurveyModalContent surveyResponse={row.value} />
        </Popup>
      )
    }},
    { text: 'Score', accessor: 'humanized_score', maxWidth: '150' },
    { text: 'Score percentage', accessor: 'humanized_score_percentage', maxWidth: '150' }
  ]

  const accordionDetails = _.map(surveyGroups, (surveyGroup, title) => ({
    title,
    subTitle: (
      <ul className="list--no-list-style list--no-padding list--horizontal">
        <li className="accordion__item-sub-title">
          <strong>
            Total responses
            {' '}
          </strong>
          {surveyGroup.length}
        </li>
        { showUserField && (
          <li className="accordion__item-sub-title">
            <strong>
              Average for this period
              {' '}
            </strong>
            {`${_.find(filteredUsers, { 'name': title }).averageScore}%`}
          </li>
        )}
      </ul>
    ),
    content: (
      <Table
        columns={accordionTableColumns}
        data={surveyGroup}
      />
    )
  }))

  return (
    <div>
      <Accordion>
        {accordionDetails}
      </Accordion>
    </div>
  )
}

export default ReportAccordion
